import { clearSelection } from "../../helpers";
import { DrawSettingsPopup } from "./settingsPopup";
import { SelectorModule } from "./selector-module.js";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import {
	touchApp, sendBackwords, bringForward, sendToBack, bringToFront,
	rotateRight, rotateLeft, flipVertical, flipHorizontal, contentCopy
} from "../../Resources/drawing-icons.js";

export class DrawSelector extends DrawingModuleContainer {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.canvas.selection = true;
		this.canvas.perPixelTargetFind = true;
		this.canvas.targetFindTolerance = 10;
		this.canvas.hoverCursor = "move";

		this.canvas.forEachObject(o => {
			o.selectable = (!o.neverSelect && !(o.moduleState && o.moduleState.neverSelect));
			if (o.type === "textbox") {
				o.editable = true;
				if (o.isEditing) o.exitEditing();
			}
		});
        
		for (const m of this.submodules) {
			if (typeof m.Activate === 'function') {
				m.Activate();
			}
		} 

		this.findSelectedObjectMouse = e => {
			if (!e.target || !e.target.canvas) return;

			let o = e.target;
			this.openModuleSettings(o, e.target.canvas);
		};

		// NOTE: commented until real user testing of double click as the only way to call settings popup on tablets
		// this.findSelectedObjectTouch = e => {
		// 	e.e.preventDefault();
		// 	let o = this.canvas.getActiveObject();
		// 	if (o) {
		// 		this.dispatchEvent(
		// 			new CustomEvent("drawing-settings-open", { composed: true })
		// 		);
		// 		this.openModuleSettings(o, this.canvas);
		// 	}
		// };

		this.canvas.on("mouse:dblclick", this.findSelectedObjectMouse);
		//this.canvas.on("touch:longpress", this.findSelectedObjectTouch);
		this.canvas.renderAll();

		return this;
	}

	openModuleSettings(o, canvas) {
		let modules = canvas.configurableModules;
		if (
			modules &&
            o.moduleName &&
            o.moduleState &&
            (o.moduleState.settingsSelect || !o.moduleState.neverSelect) &&
            modules[o.moduleName] &&
            !this.popup
		) {
			this.dispatchEvent(new CustomEvent("drawing-settings-open", { composed: true }));
            
			o.lockMovementX = o.lockMovementY = true;

			this.popup = new DrawSettingsPopup();

			let set = modules[o.moduleName].RenderSettings(o, () => {
				this.popup.remove();
				this.popup = undefined;
				o.lockMovementX = o.lockMovementY = false;
				this.dispatchEvent(
					new CustomEvent("drawing-settings-close", { composed: true })
				);
			});

			this.popup.settingsHtml = set;
			document.body.appendChild(this.popup);
		}
	}

	Deactivate() {
		clearSelection(this.canvas);
		this.canvas.off("mouse:dblclick", this.findSelectedObjectMouse);
		//this.canvas.off("touch:longpress", this.findSelectedObjectTouch);
        
		for (const m of this.submodules) {
			if (typeof m.Deactivate === 'function') {
				m.Deactivate();
			}
		}
	}
    
	firstUpdated() {
		this.submodules.forEach(s => {
			s.addEventListener("click", () => {				
				if (s.isNotActive) return;

				let target = s;
				for (let element of target.parentElement.children) {
					element.removeAttribute("selected");
				}
				target.setAttribute("selected", "selected");
				
				setTimeout(() => {
					target.removeAttribute("selected");
				}, 100);
			});
		});
	}

	constructor(canvas) {
		super(canvas);
		
		this.moduleId = "select";
		this.toolbarWidth = "50px";
		this.icon = touchApp;
		this.label = "select";
		this.activeSubmodule = null;

		const modules = [
			{ direction: "bringToFront", icon: bringToFront },
			{ direction: "bringForward", icon: bringForward },
			{ direction: "sendBackwords", icon: sendBackwords },
			{ direction: "sendToBack", icon: sendToBack },
			{ direction: "flipv", icon: flipVertical },
			{ direction: "fliph", icon: flipHorizontal },
			{ direction: "rotater", icon: rotateRight },
			{ direction: "rotatel", icon: rotateLeft },
			{ direction: "copy", icon: contentCopy },
		];
		this.submodules = modules.map(b => new SelectorModule(canvas, b.direction, b.icon));
	}
}

window.customElements.define("inspx-draw-selector", DrawSelector);
